import { useEffect } from 'react';
import { useAccount, useChainId } from 'wagmi';
import { useAnalytics } from '../lib/analytics';

export function useWalletAnalytics() {
  const { address, isConnected, connector } = useAccount();
  const chainId = useChainId();
  const analytics = useAnalytics();

  // Track initial connection
  useEffect(() => {
    if (isConnected && address) {
      // First update the session with the user's address
      analytics.updateSession({
        user_address: address
      }).then(() => {
        // Then track the connect event
        analytics.trackWalletEvent('CONNECT', {
          address,
          chainId,
          provider: connector?.name || 'unknown',
          timestamp: Date.now(),
          success: true
        });
      }).catch(error => {
        console.error('Failed to track wallet connection:', error);
      });
    }
  }, [isConnected, address, chainId, connector?.name]);

  // Track disconnection
  useEffect(() => {
    if (!isConnected && address) {
      analytics.trackWalletEvent('DISCONNECT', {
        address,
        chainId,
        timestamp: Date.now(),
        success: true
      }).catch(error => {
        console.error('Failed to track wallet disconnection:', error);
      });
    }
  }, [isConnected, address, chainId]);

  // Track chain changes
  useEffect(() => {
    if (chainId && address) {
      analytics.trackWalletEvent('SWITCH_CHAIN', {
        address,
        chainId,
        timestamp: Date.now(),
        success: true
      }).catch(error => {
        console.error('Failed to track chain switch:', error);
      });
    }
  }, [chainId, address]);

  return analytics;
}